<template>
  <div class="viq-conv-list">
    <div v-if="conversationsLoading" class="viq-conv-list__loading">
      <div class="viq-conv-list__skeleton" v-for="i in 4" :key="i" />
    </div>
    <template v-else>
      <ViqConversationItem
        v-for="conv in flatConversations"
        :key="conv.id"
        :conversation="conv"
        :active="activeConversation && activeConversation.id === conv.id"
        @select="selectConversation(conv)"
        @rename="renameConversation(conv, $event)"
        @delete="deleteConversation(conv.id)"
      />
      <div v-if="!hasConversations && !conversationsLoading" class="viq-conv-list__empty">
        No conversations yet
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ViqConversationList",
  components: {
    ViqConversationItem: () => import("./ViqConversationItem"),
  },
  computed: {
    ...mapState("Viq", ["activeConversation", "conversationsLoading", "conversations"]),
    ...mapGetters("Viq", ["hasConversations", "conversationsGrouped"]),
    flatConversations() {
      if (!this.conversations || this.conversations.length === 0) return [];
      return [...this.conversations].sort((a, b) => {
        const toNum = (v) => typeof v === "number" || /^\d+$/.test(v) ? Number(v) : new Date(v).getTime() / 1000;
        return toNum(b.updated_at || b.created_at) - toNum(a.updated_at || a.created_at);
      });
    },
  },
  methods: {
    selectConversation(conv) {
      this.$store.dispatch("Viq/loadConversation", conv.id);
    },
    renameConversation(conv, newTitle) {
      this.$store.dispatch("Viq/renameConversation", {
        id: conv.id,
        title: newTitle,
      });
    },
    deleteConversation(id) {
      this.$store.dispatch("Viq/deleteConversation", id);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-conv-list {
  &__loading {
    padding: $viq-space-sm;
  }

  &__skeleton {
    height: 52px;
    background: $viq-bg-secondary;
    border-radius: $viq-radius-sm;
    margin-bottom: $viq-space-xs;
    animation: pulse 1.5s ease-in-out infinite;
  }

  &__empty {
    padding: $viq-space-lg $viq-space-sm;
    text-align: center;
    font-size: $viq-font-sm;
    color: $viq-text-muted;
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>
